import React from 'react'

class RegistrationConfirmationComponent extends React.Component {
  render () {
    return (
        <h3 style={{ color: 'blue' }}>Please check your email to follow a link to activate your registration</h3>
    )
  }
}
export default RegistrationConfirmationComponent;